import React from 'react'
import LazyImage from '../lib/LazyImage'
import Link from '../lib/Link'
import {Text, Img} from '../field'
import {renderVideo, realPath} from '../lib/util'
//import renderExtraFields from '../field/ExtraFields'
//import EntityFields from './EntityFields'

const BlockTeaser = ({entity, block, admin, edit, menu, config, screen}) => (
	<div  id={config.id}
				className={config.classes.join(' ')}
				style={config.style}>
		{menu}
		<div className='content'><div className='content-in'>

		{(block.thumb && block.thumb.length>0) && <div className='img'><LazyImage className='img-in' src={block.thumb[0]} alt='' bg={true} screen={screen}/></div>}
		<div className='text-content'>		
			<Text entity={entity} block={block} fieldName='summary' value={block.summary}/>
				<Link to={block.link}>{block.title}</Link>
		</div>

		</div></div>
	</div>
)

const BlockList = ({block, classes, admin, edit, menu}) => (
	<div className={classes} id={`block-${block.uuid}`}>
		{menu}
		{/*
		<div className='content'>
		{(edit && edit.prop==='text')
			? <Editor args={edit} text={block.text}/>
			:<div className='text' 
				onClick={() => admin.dispatch(ops.editMode({block:block.uuid, prop: 'text'}))}
				dangerouslySetInnerHTML={{__html: block.text}}/>
				}
				<ul className='list'>
				{block.list.map((item,i) => (
					<li key={i} className='list-item'>
						{(edit && edit.prop==='list' && edit.i===i)
							? <Editor args={edit} text={item}/>
							: <div onClick={() => admin.dispatch(ops.editMode({block:block.uuid, prop: 'list', i}))} dangerouslySetInnerHTML={{__html: item}}/>
						}
					</li>
				))}
				</ul>
		</div>
		*/}
	</div>
)

const BlockHistory = ({block, classes, admin, edit, menu}) => (
	<div className={classes} id={`block-${block.uuid}`}>
		{menu}
		{/*
		<div className='content'>
		{block.faicon && <div className='faicon'><i className={`fa fa-${block.faicon}`}></i></div>}
		{edit 
			? <Editor args={edit} text={block.text}/>
			:<div className='text' 
				onClick={() => admin.dispatch(ops.editMode({block:block.uuid}))}
				dangerouslySetInnerHTML={{__html: block.listin}}/>
				}
		</div>
		*/}
	</div>
)

//if (block.ga && block.ga.trim()!=='') style.gridArea = block.ga
const BlockIcon = ({entity, block, admin, edit, menu, config}) => (
	<div id={config.id}
				className={config.classes.join(' ')}
				style={config.style}>
	{/*className={classes} id={`block-${block.uuid}`} 
		style={(block.ga && block.ga.trim()!=='')?{gridArea: block.ga}:{}}>*/}
		{menu}
		<Img src={block.img} classes='field-img' screen={config.screen}/>
		<Text entity={entity} block={block} fieldName='text' value={block.text}/>
	</div>
)

const BlockAction = ({block, edit, menu, config}) => (
	<div id={config.id}
				className={config.classes.join(' ')}
				style={config.style}>
				{/*className={classes} id={`block-${block.uuid}`}
		style={(block.ga && block.ga.trim()!=='')?{gridArea: block.ga}:{}}>*/}
		{menu}
		<Link to={block.link}>
			{block.call} <i className={`fa fa-${block.icon}`}></i>
		</Link>
	</div>
)
/*
const forms = Object.assign({}, customForms)

const renderForm = form => {
	if(!form || !forms[form]) return null
	let Form = forms[form]
	return <Form/>
}
const BlockForm = ({classes, block, children}) => (
	<div className={classes} id={block.p===null?`section-${block.uuid}`:undefined}>
		{children}
		{renderForm(block.form)}
	</div>
)
*/

const BlockVideo = ({entity, block, menu, config}) => (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{menu}
		<div className='block-in'><div className={config.contentClasses.join(' ')} style={config.contentStyle}>
			{renderVideo(block.video)}
			{block.vid && block.vid.length>0 &&
				<video playsInline autoPlay muted loop >
    				<source src={realPath(block.vid[0].url)} type="video/mp4"/>
				</video>
			}
		</div></div>
	</div>
)

const BlockRegion = ({entity, block, menu, config, childBlocks}) => (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{menu}
		<div className='block-in'><div className={config.contentClasses.join(' ')} style={config.contentStyle}>
			{childBlocks}
		</div></div>
	</div>
)


/*
const BlockSimple = ({mq, classes, entity, block, node, menu, childBlocks, edit, admin}) => {
	let blockClasses = classes
	let blockStyle={}
	let contentClasses = 'content'
	let contentStyle = {}
	
	const id = `block-${block.uuid}`

	if (block.bgProp) blockClasses += ' bg-prop'
	if (block.border) blockClasses += ' border'
	if (block.bgColor) blockStyle.backgroundColor = block.bgColor
	if (block.ga && block.ga.trim()!=='') blockStyle.gridArea = block.ga
	if(block.layout) blockClasses += ' ' + block.layout
	blockClasses += (block.o?(' horizontal cols-'+ childBlocks.length):'')

	return (
	<div id={id}
		className={blockClasses}
		style={blockStyle}>
		<Bg bg={block.bg} proportional={block.bgProp} container={`#${id} > .block-in`}/>
		{menu}
		<div className='block-in'><div className={contentClasses} style={contentStyle}>
			{childBlocks}
			{renderExtraFields(entity, block)}
		</div></div>
	</div>
)}
*/
export {BlockTeaser, BlockList, BlockHistory, BlockIcon, BlockAction, BlockVideo, BlockRegion}


// WEBPACK FOOTER //
// ./src/fm/block/Blocks.js